import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { SnackbarProvider } from 'notistack';
import * as Sentry from "@sentry/react";
import 'antd/dist/reset.css';
import './i18n';

const isProduction = process.env.NODE_ENV === 'production';
const release = process.env.VITE_RELEASE || process.env.VITE_GIT_SHA || undefined;
const sentryDsn = process.env.VITE_SENTRY_DSN;
const sentrySendPii = process.env.VITE_SENTRY_SEND_PII === 'true';

const scrubSentryEvent = (event) => {
  if (event?.request?.url) {
    event.request.url = String(event.request.url).split('?')[0];
  }
  if (event?.request?.headers) {
    delete event.request.headers.authorization;
    delete event.request.headers.Authorization;
    delete event.request.headers.cookie;
    delete event.request.headers.Cookie;
  }
  if (event?.user && !sentrySendPii) {
    delete event.user.email;
    delete event.user.ip_address;
  }
  return event;
};

if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: process.env.NODE_ENV || 'development',
    release,
    sendDefaultPii: sentrySendPii,
    tracesSampleRate: isProduction ? 0.1 : 1.0,
    replaysSessionSampleRate: isProduction ? 0.05 : 0,
    replaysOnErrorSampleRate: isProduction ? 1.0 : 0,
    beforeSend: scrubSentryEvent,
  });
}

const root = createRoot(document.getElementById('root'));
root.render(
  <SnackbarProvider
    maxSnack={3}
    anchorOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    autoHideDuration={5000}
  >
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </SnackbarProvider>
);

